"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectEntityList = detectEntityList;
exports.entityListItems = entityListItems;
exports.decodeEntityList = decodeEntityList;
exports.isPlaceholderContainer = isPlaceholderContainer;
const decoded_types_1 = require("../decoded-types");
const typeCodes_1 = require("../typeCodes");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
function detectEntityList(children) {
    if (children.length < 2) {
        return null;
    }
    const first = children[0];
    const second = children[1];
    if (first.type !== 'atom' || second.type !== 'atom') {
        return null;
    }
    const declaredCount = parseInt(first.content, 10);
    if (!Number.isFinite(declaredCount)) {
        return null;
    }
    const typeCode = second.content.trim();
    if (!/^\d+$/.test(typeCode)) {
        return null;
    }
    return { typeCode, declaredCount };
}
function entityListItems(node) {
    const out = [];
    for (let i = 2; i < node.children.length; i++) {
        const child = node.children[i];
        if (child.type === 'atom') {
            continue;
        }
        out.push(child);
    }
    return out;
}
function decodeEntityList(node, expectedTypeCode, path, warnings, decodeItem) {
    if (node.type !== 'container' && node.type !== 'econtainer') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for entity-list, found ${node.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return null;
    }
    const detected = detectEntityList(node.children);
    if (detected === null) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `container does not open with (count, typeCode) atoms`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return null;
    }
    if (expectedTypeCode !== null && detected.typeCode !== expectedTypeCode) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnknownTypeCode,
            message: `expected typeCode=${expectedTypeCode}, found ${detected.typeCode}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return null;
    }
    const itemNodes = entityListItems(node);
    if (itemNodes.length !== detected.declaredCount) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.InvariantViolation,
            message: `entity-list declared count=${detected.declaredCount} but found ${itemNodes.length} items`,
            severity: sigma_engine_shared_1.BoundaryLevel.Error,
            path,
        });
    }
    const declaredTypeCode = expectedTypeCode !== null ? expectedTypeCode : ((0, typeCodes_1.asTypeCode)(detected.typeCode) ?? detected.typeCode);
    const items = itemNodes.map((item, index) => decodeItem(item, index, `${path}/items[${index}]`));
    return {
        kind: 'entity-list',
        declaredTypeCode,
        declaredCount: detected.declaredCount,
        items,
        raw: node,
    };
}
function isPlaceholderContainer(node) {
    if (node.type !== 'container' && node.type !== 'econtainer') {
        return false;
    }
    if (node.children.length !== 1) {
        return false;
    }
    const only = node.children[0];
    return only.type === 'atom' && only.content.trim() === '0';
}
//# sourceMappingURL=entity-list.js.map